'use strict'

/**
 * Project janux-vuejs-seed
 * Created by hielo on 2018-05-07
 */

import loginComponent from './login-component'
import logoutComponent from './logout-component'
import forgotPassword from './forgot-password'
import recoverPassword from './recover-password'

const routes = [
	{
		path: '/connect/:goodbye?/:redirect?',
		name: 'connect',
		props: true,
		component: loginComponent
	},
	{
		path: '/disconnect',
		name: 'disconnect',
		props: false,
		component: logoutComponent
	},
	{
		path: '/forgot-password',
		name: 'forgot-password',
		props: false,
		component: forgotPassword
	},
	{
		path: '/recover/:code',
		name: 'recover',
		props: true,
		component: recoverPassword
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/app/login/index.js